import {QueryDefinition} from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import {store} from '../../../app/store';
import {FieldFilter} from '../../../app/utils/filter';
import {Applikasjon, PaginatedResult, Systemparameter} from '../../../models';
import {systemparameterService} from '../../services';
import {TBaseQueryFn, TEntityDefinitions} from '../queryApiCreator';
import {QueryApiService} from '../queryApiService';

interface SystemparameterDefinitions extends TEntityDefinitions<Systemparameter, typeof systemparameterService.typeName> {
    searchApplikasjoner: QueryDefinition<string, TBaseQueryFn<any>, any, PaginatedResult<Applikasjon>>,
    searchTyper: QueryDefinition<string, TBaseQueryFn<any>, any, PaginatedResult<string>>,
    searchParentSystemparameter: QueryDefinition<string, TBaseQueryFn<any>, any, PaginatedResult<string>>,
    sjekkSystemparameter: QueryDefinition<{id: string; condition: FieldFilter}, TBaseQueryFn<any>, any, boolean, 'api'>
}

class SystemparameterQueryApiService extends QueryApiService<Systemparameter, typeof systemparameterService.typeName, SystemparameterDefinitions> {

    constructor() {
        super(systemparameterService);
        this.api.injectEndpoints({
            endpoints: (build) => {
                return {
                    searchApplikasjoner: build.query<PaginatedResult<Applikasjon>, string>({
                        query: (query: string)  => {
                            return ({ request: systemparameterService.applikasjoner(query), meta: query });
                        }
                    }),
                    searchTyper: build.query<PaginatedResult<string>, string>({
                        query: (query: string) => {
                            return ({ request: systemparameterService.typer(query), meta: query });
                        }
                    }),
                    searchParentSystemparameter: build.query<PaginatedResult<string>, string>({
                        query: (query: string) => {
                            return ({ request: systemparameterService.parentSystemparameter(query), meta: query });
                        }
                    }),
                    sjekkSystemparameter: build.query<boolean, {id: string, condition: FieldFilter}>({
                        query: ({id, condition}) =>  ({ request: systemparameterService.sjekkParameter(id, condition) }),
                        providesTags: [{ type: systemparameterService.typeName, id: 'LIST' }]
                    }),
                    
                };
            },
        });
    }

    get applikasjonerOptionsPlainSearch() {
        return async (searchString: string, predicate?: (value: Applikasjon) => boolean) => {
            const result = (await store.dispatch(this.api.endpoints.searchApplikasjoner.initiate(searchString))).data?.value;
            return predicate && result ? result.filter(predicate) : result ?? [];
        };
    }

}


export const systemparameterQueryApiService = new SystemparameterQueryApiService();
